import { Button, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <Stack align="flex-start">
      <Title order={2}>Página no encontrada</Title>
      <Text c="dimmed">La dirección no existe o se ha movido.</Text>
      <Button component={Link} to="/">
        Ir al inicio
      </Button>
    </Stack>
  );
}
